<template>
  <footer class="footer">
    <div class="footer-container">
      
      <div class="footer-brand">
        <h3>JPFC</h3>
        <p>Employee time tracking and timesheets for any business.</p>
      </div>

      <div class="footer-links">
        <div>
          <h4>Product</h4>
          <RouterLink to="/pricing">Pricing</RouterLink>
        </div>

        <div>
          <h4>Company</h4>
          <a href="mailto:support@miss-kal.uk">Support</a>
        </div>

        <div>
          <h4>Legal</h4>
          <a href="/privacypolicy">Privacy</a>
          <a href="/termsofuse">Terms</a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      © {{ year }} JPFC. All rights reserved.
    </div>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear()
</script>
<style scoped>
.footer {
  background: #111827;
  color: #e5e7eb;
  margin-top: 3rem;
  padding: 2rem 1rem 1rem;
}

.footer-container {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
}

.footer-brand h3 {
  margin: 0;
}

.footer-brand p {
  color: #9ca3af;
  font-size: 0.9rem;
}

.footer-links {
  display: flex;
  gap: 3rem;
}

.footer-links h4 {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #9ca3af;
}

.footer-links a {
  display: block;
  text-decoration: none;
  color: #e5e7eb;
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-bottom {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.8rem;
  color: #6b7280;
}
</style>
